import {
  filterVar
} from './variables';

export function setFilter( newValue ) {
  filterVar( newValue );
}